<script>
  var options = {
    series: [
      {
        name: "P&L",
        type: "column",
        data: [23, -11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
      },
      {
        name: "Cumulative Profit",
        type: "area",
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
      },
      {
        name: "Drawdown",
        type: "line",
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      },
    ],
    chart: {
      height: 350,
      type: "line",
      stacked: false,
    },
    stroke: {
      width: [0, 2, 5],
      curve: "smooth",
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },

    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100],
      },
    },
    labels: [
      "01/01/2003",
      "02/01/2003",
      "03/01/2003",
      "04/01/2003",
      "05/01/2003",
      "06/01/2003",
      "07/01/2003",
      "08/01/2003",
      "09/01/2003",
      "10/01/2003",
      "11/01/2003",
    ],
    markers: {
      size: 0,
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      title: {
        text: "Points",
      },
      min: 0,
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0) + " points";
          }
          return y;
        },
      },
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    window.ApexCharts &&
      new ApexCharts(
        document.getElementById("chart-demo-line"),
        options
      ).render();
  });
</script>

<div class="col-12">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Strategy Name</h3>
    </div>
  </div>
</div>

<div class="col-lg-4">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Strategy Stats</h3>
      <div class="ms-auto">
        <span class=" bg-green-lt">+23000</span>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table card-table table-vcenter text-nowrap datatable">
        <tbody>
          <tr
            ><td>Total Trades</td>
            <td class=" bg-yellow-lt">58</td></tr
          >
          <tr
            ><td>Total Expiry</td>
            <td class=" bg-yellow-lt">17</td></tr
          >
          <tr
            ><td>Total Wins</td>
            <td class=" bg-green-lt">38</td></tr
          >
          <tr
            ><td>Total Loss</td>
            <td class=" bg-red-lt">56</td></tr
          >
          <tr
            ><td>Winning Streak</td>
            <td class=" bg-green-lt">38</td></tr
          >
          <tr
            ><td>Lossing Streak</td>
            <td class=" bg-red-lt">56</td></tr
          >
          <tr
            ><td>Daily Avg</td>
            <td class=" bg-red-lt">-1005</td></tr
          >
          <tr
            ><td>Expiry Average</td>
            <td class=" bg-red-lt">-545</td></tr
          >
          <tr
            ><td>Max Gains</td>
            <td class=" bg-green-lt">+1460</td></tr
          >
          <tr
            ><td>Max Loss</td>
            <td class=" bg-red-lt">-2458</td></tr
          >
          <tr
            ><td>Avg on win Days</td>
            <td class=" bg-green-lt">+457</td></tr
          >
          <tr
            ><td>Avg on Loss Days</td>
            <td class=" bg-red-lt">-124</td></tr
          >
          <tr
            ><td>Max Drawdown</td>
            <td class=" bg-red-lt">-8752</td></tr
          >
          <tr
            ><td>Return to MDD Ratio</td>
            <td class=" bg-green-lt">8.9</td></tr
          >
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="col-lg-8">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Monthly Report</h3>
    </div>

    <div class="table-responsive">
      <table class="table card-table table-vcenter text-nowrap datatable">
        <tbody>
          <tr>
            <td />
            <td>2020</td>
            <td>2021</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td class="bg-green-lt">45789</td>
            <td class="bg-red-lt">-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Jan</td>
            <td>45789</td>
            <td>-85789</td>
          </tr>
          <tr>
            <td>Total</td>
            <td>8754</td>
            <td>-8718</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="col-lg-12">
  <div class="card">
    <div class="card-body">
      <div id="chart-demo-line" class="chart-lg" />
    </div>
  </div>
</div>
